import { createFileRoute } from "@tanstack/react-router"

import { query } from "@/api/query"
import { MY_SPACE } from "@/constants/spaces"
import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/_sidebar/integrations/")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context)
  },
  loader: ({ context: { queryClient, spaceStorage } }) => {
    const space = spaceStorage.getSpace()

    queryClient.query({ ...query.space.subscriptions(space), staleTime: "static" })
    queryClient.query({ ...query.space.subscriptions(MY_SPACE.id), staleTime: "static" })
  },
  head: () => ({
    meta: [
      {
        title: "Integrations | Arduino Cloud"
      }
    ]
  })
})
